// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3bg_b","addWidgetButton":"Header_addWidgetButton__pXOxe","dashboardTabs":"Header_dashboardTabs__2peyi","active":"Header_active__1yFqk"};